<template>
  <el-aside width="250px">
    <el-menu
      class="submenu submenu-recruit"
      :default-active="activeIndex"
    >
      <h1>个险招募</h1>
      <el-menu-item
        index="businessExplanation"
        v-for="(cell, idx) in children || []"
        @click="go_Recruit(cell.url)"
        :key="idx"
      >
        <template #title>{{ cell.privName }}</template>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: "recruitSidebar",
  props: {
    children: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: ''
    };
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    },
    go_Recruit(url){
      this.$emit('go_Recruit_page', url);
    }
  }
};
</script>

<style lang="scss" scoped>
.submenu {
  background: rgba(247, 247, 247, 1);

  h1 {
    text-align: center;
    font-size: 18px;
    color: rgba(153, 153, 153, 1);
    height: 100px;
    line-height: 100px;
    padding: 0;
    margin: 0;
    font-weight: normal;
  }

  .el-menu,
  .el-dropdown-menu__item--divided:before,
  .el-menu,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background-color: #f7f7f7;
  }

  > .el-menu-item {
    color: #5876b9;
    padding-left: 20% !important;
    border-top: 1px solid #e5e5e5;

    &:focus,
    &:hover {
      background-color: #5b9fec;
      color: #fff;
    }
  }

  :deep(.el-submenu__title) {
    color: #5876b9;
    border-top: 1px solid #e5e5e5;
    height: 58px;
    line-height: 58px;
    padding-left: 20% !important;

    &:focus,
    &:hover {
      background-color: #5b9fec;
      color: #fff;
    }

    + .el-menu .el-menu-item {
      background-color: #f7f7f7;

      &:active,
      &:focus,
      &:hover {
        background-color: #f7f7f7;
        color: #999;

        span {
          color: #409eff;

          &:after {
            color: #409eff;
          }

          &:before {
            background-color: #409eff;
          }
        }
      }
    }
  }
}

.el-aside {
  background: rgba(247, 247, 247, 1);
  -webkit-box-shadow: 3px 0px 5px 0px rgba(162, 187, 225, 0.3);
  box-shadow: 3px 0px 5px 0px rgba(162, 187, 225, 0.3);
  height: 100%;
  width: 200px;
  z-index: 999;
}

:deep(.el-submenu .el-menu-item span) {
  position: relative;
  display: block;
  color: #999;
  padding-left: 20%;

  &:before {
    content: "";
    position: absolute;
    background-color: #e4e7ed;
    border-radius: 50%;
    z-index: 10;
    width: 10px;
    height: 10px;
    top: 20px;
    left: 0px;
  }

  &:after {
    content: "";
    position: absolute;
    left: 4px;
    height: 100%;
    border-left: 2px solid #e4e7ed;
    z-index: 9;
  }

  &:first-child:after {
    top: 20px;
  }

  &:last-child:after {
    bottom: 20px;
  }
}

.submenu-recruit > .el-menu-item {
  padding-left: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/layout/RecruitSidebar.vue